import MicroModal from 'micromodal'
MicroModal.init({
    disableScroll:true,
})

document.addEventListener('DOMContentLoaded', () => {
    const modalTriggers = document.querySelectorAll('[data-micromodal-trigger]')
    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => e.preventDefault() )
    })
    
    const modalAutoOpen = document.querySelectorAll('[data-modal-auto-open]')
    modalAutoOpen.forEach(modal => {
        MicroModal.show(modal.id)
    })
});
